export default {"src":"/_next/static/media/Kevin.867311cd.svg","height":45,"width":45,"blurWidth":0,"blurHeight":0};